module.exports = __webpack_public_path__ + "public/img/menubg.2c4ba290.png";